
  import { computed, defineComponent, ref, watch } from 'vue';
  import { changeVideoMute } from '@/store/settings';
  import { VueDraggableNext } from 'vue-draggable-next';
  import { hangUp } from '@/store/calls';

  export default defineComponent({
    name: 'DraggableBlock',
    components: {
      VueDraggableNext,
    },
    props: {
      isRemoteVideoMute: {
        type: Boolean,
        default: false,
      },
    },
    setup(props) {
      const enabled = ref(true);
      const dragging = ref(false);
      const activeBorder = ref(false);
      const videoIndex = ref(1);
      const list = ref([
        { type: 'slot', id: 0 },
        { type: 'video', id: 1 },
        { type: 'slot', id: 2 },
      ]);
      const isButtonHolding = ref(false);
      const slotClasses = computed(() => ({
        slot: !dragging.value && !isButtonHolding.value,
        'slot-active': dragging.value || isButtonHolding.value,
      }));
      const startDrag = () => (dragging.value = true);
      const endDrag = (ev) => {
        videoIndex.value = ev.newIndex;
        activeBorder.value = false;
        isButtonHolding.value = false;
        dragging.value = false;
      };
      hangUp.watch(() => (activeBorder.value = false));

      changeVideoMute.watch((state) => (enabled.value = !state));
      watch(props, (state) => (enabled.value = !state.isRemoteVideoMute));
      watch(dragging, (state: boolean) => {
        if (state) document.body.style.cursor = 'grabbing';
        else document.body.style.cursor = 'default';
      });
      const videoBlockClasses = computed(() => ({
        'draggable-video': enabled.value,
        'video-in-window': enabled.value,
        'video-border': activeBorder.value,
        'dragging-style': dragging.value && enabled.value,
        'left-margin': videoIndex.value !== 1,
        'right-margin': videoIndex.value === 1,
        'top-margin': videoIndex.value !== 2,
        'bottom-margin': videoIndex.value === 2,
      }));
      const setActiveBorder = (status: boolean) => {
        isButtonHolding.value = status;
        if (enabled.value) activeBorder.value = status;
      };
      return {
        list,
        enabled,
        dragging,
        startDrag,
        endDrag,
        videoBlockClasses,
        slotClasses,
        setActiveBorder,
      };
    },
  });
